// extracted by mini-css-extract-plugin
export default {"outcome":"RecipientsTable_outcome__fGywP","daniel":"RecipientsTable_daniel__Aeye+","truncatedText":"RecipientsTable_truncatedText__ndAyg"};